import { OrderState } from './interfaces';

const BASKET_CONSTANTS = {
  order: {
    isLoading: true,
    pre_order_id: '',
    currency_id: '1',
    currency_nominal: 0,
    currency_rate: 0,
    date: '',
    id: '',
    language_id: '1',
    order_price: 0,
    products: [],
    pre_order_products: [],
    editProduct: null,
  } as OrderState,
};
export default BASKET_CONSTANTS;
